import React from "react";
import { FacetValue } from "../types";
import { toPascalCase } from "../batchStatusHelper";

interface BatchSummaryBarProps {
  title: string;
  facets: FacetValue[];
  colorMap: Record<string, string>;
  selectedValues: string[];
  onToggle: (value: string) => void;
}

function getColor(colorMap: Record<string, string>, value: string): string {
  return colorMap[value] || colorMap[value.toLowerCase()] || "#A19F9D";
}

export const BatchSummaryBar: React.FC<BatchSummaryBarProps> = ({ title, facets, colorMap, selectedValues, onToggle }) => {
  const total = facets.reduce((sum, f) => sum + f.count, 0);

  return (
    <div style={{ marginBottom: '1rem' }}>
      <h3 style={{ fontSize: '0.8125rem', fontWeight: 600, margin: '0 0 0.25rem 0', color: "#323130" }}>{title}</h3>
      <div style={{ display: "flex", height: '1.5rem', borderRadius: '0.25rem', overflow: "hidden", backgroundColor: "#F3F2F1" }}>
        {facets.map((facet) => {
          const widthPercent = total > 0 ? (facet.count / total) * 100 : 0;
          const isSelected = selectedValues.length === 0 || selectedValues.includes(facet.value);
          return (
            <div
              key={facet.value}
              onClick={() => onToggle(facet.value)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onToggle(facet.value); } }}
              role="button"
              tabIndex={0}
              aria-label={`${facet.value}: ${facet.count}`}
              aria-pressed={isSelected}
              style={{
                width: `${widthPercent}%`,
                backgroundColor: getColor(colorMap, facet.value),
                opacity: isSelected ? 1 : 0.3,
                cursor: "pointer",
                transition: "opacity 0.2s",
                minWidth: widthPercent > 0 ? 4 : 0,
              }}
              title={`${toPascalCase(facet.value)}: ${facet.count}`}
            />
          );
        })}
      </div>
      <div style={{ display: "flex", gap: '0.75rem', marginTop: '0.25rem', flexWrap: "wrap" }}>
        {facets.map((facet) => {
          const isSelected = selectedValues.length === 0 || selectedValues.includes(facet.value);
          return (
            <span
              key={facet.value}
              onClick={() => onToggle(facet.value)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onToggle(facet.value); } }}
              role="button"
              tabIndex={0}
              aria-label={`Toggle ${facet.value} filter`}
              aria-pressed={isSelected}
              style={{ fontSize: '0.75rem', cursor: "pointer", opacity: isSelected ? 1 : 0.5, display: "flex", alignItems: "center", gap: '0.25rem', borderRadius: '0.25rem', padding: "0.125rem 0.25rem", scrollMargin: '0.5rem' }}
            >
              <span style={{ width: 10, height: 10, borderRadius: "50%", backgroundColor: getColor(colorMap, facet.value), display: "inline-block" }} />
              {toPascalCase(facet.value)} ({facet.count})
            </span>
          );
        })}
      </div>
    </div>
  );
};
